import { render, staticRenderFns } from "./ModalWorkConsult.vue?vue&type=template&id=2bbf470c&"
import script from "./ModalWorkConsult.vue?vue&type=script&lang=js&"
export * from "./ModalWorkConsult.vue?vue&type=script&lang=js&"
import style0 from "./ModalWorkConsult.vue?vue&type=style&index=0&id=2bbf470c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports